module.exports = __webpack_public_path__ + "img/2009_L.a4faabff.png";